// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./admin-variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared Admin Form Styles */

/* Form Container */
.admin-form-container {
  width: 100%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Main container for card-less layout */
.admin-form-main-container {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 1rem 2rem;
  border-radius: var(--radius-xl);
}

/* Page Header */
.admin-form-header {
  background-color: #7d48b0;
  padding: 4px 8px;
  border-radius: 4px;
  color: white !important;
    margin-bottom: 0.5rem;
}

.admin-form-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--surface-white);
  text-transform: uppercase;
  text-align: left;
}

/* Modern Form Layout */
.admin-modern-form {
  width: 100%;
}

/* Form Content Wrapper */
.admin-form-content-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  margin-bottom: 2rem;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: 1px;
    background: #9ca3afa1;
    transform: translateX(-50%);
  }

  @media (max-width: 1400px) {
    grid-template-columns: 1fr 450px;
    gap: 3rem;
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}

/* Form Columns */
.admin-form-left-column {
  flex: 1;
}

.admin-form-right-column {
  width: 100%;

  @media (max-width: 1400px) {
    max-width: 450px;
  }

  @media (max-width: 1200px) {
    max-width: none;
  }
}

/* Form Sections */
.admin-form-section {
  margin-bottom: 2rem;
}

/* Bottom Submit Button */
.admin-form-actions-bottom {
  text-align: center;
  padding: 2rem 0 1rem;
  border-top: 2px solid var(--border-light);
  margin-top: 2rem;
}

/* Compact Grid System */
.admin-form-grid {
  display: grid;
  gap: 1rem;
}

.admin-form-grid-two-columns {
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}

.admin-form-grid-three-columns {
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr 1fr;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}

/* Compact Form Item Styling */
.admin-modern-form .ant-form-item {
  margin-bottom: 0.75rem;

  .ant-form-item-label {
    padding-bottom: 0.25rem;
    margin-bottom: 0;

    > label {
      font-weight: 500;
      color: var(--text-primary);
      font-size: 0.875rem;
      text-transform: none;
      letter-spacing: 0;
      line-height: 1.4;

      &::after {
        content: none;
      }

      &.ant-form-item-required::before {
        content: "*";
        color: var(--danger-color);
        font-weight: bold;
        margin-right: 4px;
        font-size: 0.9rem;
      }
    }
  }

  .ant-form-item-control {
    margin-bottom: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

/* Compact Input Styling */
.admin-modern-form .ant-input,
.admin-modern-form .ant-input-password,
.admin-modern-form .ant-select-selector,
.admin-modern-form .ant-picker {
  border: 1px solid #d1d5db !important;
  border-radius: var(--radius-md);
  padding: 8px 12px;
  font-size: 0.9rem;
  font-weight: 400;
  transition: all 0.2s ease;
  background: var(--surface-white);
  height: 38px;
  line-height: 1.4;

  &:hover {
    border-color: var(--primary-light);
    box-shadow: 0 0 0 1px rgba(239, 130, 0, 0.2);
  }

  &:focus,
  &.ant-input-focused,
  &.ant-select-focused {
    border-color: var(--primary-color);
    box-shadow: 0 0 0 2px rgba(239, 130, 0, 0.2);
  }
}

/* Fix password input alignment */
.admin-modern-form .ant-input-password {
  .ant-input {
    border: none !important;
    padding: 0;
    height: auto;
    line-height: 1.4;
    display: flex;
    align-items: center;
    box-shadow: none !important;
  }

  .ant-input-suffix {
    display: flex;
    align-items: center;
  }
}

/* Enhanced Checkbox and Radio Styling */
.admin-modern-form .ant-checkbox-wrapper,
.admin-modern-form .ant-radio-wrapper {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  border: 1px solid #9ca3af;
  border-radius: var(--radius-md);
  transition: all 0.2s ease;
  background: var(--surface-gray-50);

  &:hover {
    background: var(--surface-white);
    border-color: var(--primary-light);
    box-shadow: var(--shadow-sm);
  }
}

/* Permissions Grid Layout */
.admin-permissions-grid {
  .ant-checkbox-group {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 0.75rem;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
}

.admin-modern-form .ant-checkbox-wrapper {
  width: 100%;

  .ant-checkbox {
    .ant-checkbox-inner {
      width: 20px;
      height: 20px;
      border-radius: var(--radius-sm);
      border: 2px solid #9ca3af !important;
      transition: all 0.2s ease;

      &::after {
        width: 6px;
        height: 10px;
        border-width: 0 3px 3px 0;
      }
    }

    &.ant-checkbox-checked .ant-checkbox-inner {
      background: var(--primary-gradient);
      border-color: var(--primary-color);
    }
  }

  span:last-child {
    font-weight: 500;
    color: var(--text-primary);
    margin-left: 0.5rem;
  }
}

/* Submit Button */
.admin-create-btn {
  min-width: 220px;
  height: 44px;
  font-size: 1rem;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  border: none;
  border-radius: var(--radius-md);
  background: var(--primary-color);
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;

  &:hover {
    background: #d97706;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(1px);
  }

  &[disabled] {
    background: var(--text-muted);
    box-shadow: none;
    transform: none;
  }
}

/* Custom Editor Styling */
.admin-custom-editor-wrapper {
  border: 2px solid var(--border-light);
  border-radius: var(--radius-lg);
  overflow: hidden;
  transition: all 0.2s ease;
  background: var(--surface-white);

  &:hover {
    border-color: var(--primary-light);
    box-shadow: 0 0 0 3px rgb(239 130 0 / 0.1);
  }

  &:focus-within {
    border-color: var(--primary-color);
    box-shadow: 0 0 0 4px rgb(239 130 0 / 0.15);
  }

  .admin-form-right-column & {
    margin-top: 0;
    min-height: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./styles/admin-forms.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAG7B,mBAAmB;AACnB;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;IACrB,qBAAqB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;;EAElB;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,MAAM;IACN,SAAS;IACT,UAAU;IACV,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,gCAAgC;IAChC,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA,iBAAiB;AACjB;EACE,OAAO;AACT;;AAEA;EACE,WAAW;;EAEX;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;;EAE9B;IACE,0BAA0B;IAC1B,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kCAAkC;;EAElC;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;AACF;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;;EAEtB;IACE,uBAAuB;IACvB,gBAAgB;;IAEhB;MACE,gBAAgB;MAChB,0BAA0B;MAC1B,mBAAmB;MACnB,oBAAoB;MACpB,iBAAiB;MACjB,gBAAgB;;MAEhB;QACE,aAAa;MACf;;MAEA;QACE,YAAY;QACZ,0BAA0B;QAC1B,iBAAiB;QACjB,iBAAiB;QACjB,iBAAiB;MACnB;IACF;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,0BAA0B;AAC1B;;;;EAIE,oCAAoC;EACpC,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;;EAEhB;IACE,kCAAkC;IAClC,4CAA4C;EAC9C;;EAEA;;;IAGE,kCAAkC;IAClC,4CAA4C;EAC9C;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA,wCAAwC;AACxC;;EAEE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;EACzB,kCAAkC;;EAElC;IACE,gCAAgC;IAChC,kCAAkC;IAClC,4BAA4B;EAC9B;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,WAAW;IACX,aAAa;IACb,2DAA2D;IAC3D,YAAY;;IAEZ;MACE,0BAA0B;IAC5B;EACF;AACF;;AAEA;EACE,WAAW;;EAEX;IACE;MACE,WAAW;MACX,YAAY;MACZ,+BAA+B;MAC/B,oCAAoC;MACpC,yBAAyB;;MAEzB;QACE,UAAU;QACV,YAAY;QACZ,yBAAyB;MAC3B;IACF;;IAEA;MACE,mCAAmC;MACnC,kCAAkC;IACpC;EACF;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;EACrB;AACF;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;EACZ,wCAAwC;EACxC,yBAAyB;;EAEzB;IACE,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,0BAA0B;AAC1B;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;;EAEhC;IACE,kCAAkC;IAClC,0CAA0C;EAC5C;;EAEA;IACE,kCAAkC;IAClC,2CAA2C;EAC7C;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;AACF","sourcesContent":["/* Shared Admin Form Styles */\n@import './admin-variables.css';\n\n/* Form Container */\n.admin-form-container {\n  width: 100%;\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Main container for card-less layout */\n.admin-form-main-container {\n  width: 100%;\n  max-width: 1600px;\n  margin: 0 auto;\n  padding: 1rem 2rem;\n  border-radius: var(--radius-xl);\n}\n\n/* Page Header */\n.admin-form-header {\n  background-color: #7d48b0;\n  padding: 4px 8px;\n  border-radius: 4px;\n  color: white !important;\n    margin-bottom: 0.5rem;\n}\n\n.admin-form-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--surface-white);\n  text-transform: uppercase;\n  text-align: left;\n}\n\n/* Modern Form Layout */\n.admin-modern-form {\n  width: 100%;\n}\n\n/* Form Content Wrapper */\n.admin-form-content-wrapper {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4rem;\n  margin-bottom: 2rem;\n  position: relative;\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 50%;\n    top: 0;\n    bottom: 0;\n    width: 1px;\n    background: #9ca3afa1;\n    transform: translateX(-50%);\n  }\n\n  @media (max-width: 1400px) {\n    grid-template-columns: 1fr 450px;\n    gap: 3rem;\n  }\n\n  @media (max-width: 1200px) {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n}\n\n/* Form Columns */\n.admin-form-left-column {\n  flex: 1;\n}\n\n.admin-form-right-column {\n  width: 100%;\n\n  @media (max-width: 1400px) {\n    max-width: 450px;\n  }\n\n  @media (max-width: 1200px) {\n    max-width: none;\n  }\n}\n\n/* Form Sections */\n.admin-form-section {\n  margin-bottom: 2rem;\n}\n\n/* Bottom Submit Button */\n.admin-form-actions-bottom {\n  text-align: center;\n  padding: 2rem 0 1rem;\n  border-top: 2px solid var(--border-light);\n  margin-top: 2rem;\n}\n\n/* Compact Grid System */\n.admin-form-grid {\n  display: grid;\n  gap: 1rem;\n}\n\n.admin-form-grid-two-columns {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: 1fr 1fr;\n\n  @media (max-width: 768px) {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n}\n\n.admin-form-grid-three-columns {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: 1fr 1fr 1fr;\n\n  @media (max-width: 1024px) {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  @media (max-width: 768px) {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n}\n\n/* Compact Form Item Styling */\n.admin-modern-form .ant-form-item {\n  margin-bottom: 0.75rem;\n\n  .ant-form-item-label {\n    padding-bottom: 0.25rem;\n    margin-bottom: 0;\n\n    > label {\n      font-weight: 500;\n      color: var(--text-primary);\n      font-size: 0.875rem;\n      text-transform: none;\n      letter-spacing: 0;\n      line-height: 1.4;\n\n      &::after {\n        content: none;\n      }\n\n      &.ant-form-item-required::before {\n        content: \"*\";\n        color: var(--danger-color);\n        font-weight: bold;\n        margin-right: 4px;\n        font-size: 0.9rem;\n      }\n    }\n  }\n\n  .ant-form-item-control {\n    margin-bottom: 0;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n/* Compact Input Styling */\n.admin-modern-form .ant-input,\n.admin-modern-form .ant-input-password,\n.admin-modern-form .ant-select-selector,\n.admin-modern-form .ant-picker {\n  border: 1px solid #d1d5db !important;\n  border-radius: var(--radius-md);\n  padding: 8px 12px;\n  font-size: 0.9rem;\n  font-weight: 400;\n  transition: all 0.2s ease;\n  background: var(--surface-white);\n  height: 38px;\n  line-height: 1.4;\n\n  &:hover {\n    border-color: var(--primary-light);\n    box-shadow: 0 0 0 1px rgba(239, 130, 0, 0.2);\n  }\n\n  &:focus,\n  &.ant-input-focused,\n  &.ant-select-focused {\n    border-color: var(--primary-color);\n    box-shadow: 0 0 0 2px rgba(239, 130, 0, 0.2);\n  }\n}\n\n/* Fix password input alignment */\n.admin-modern-form .ant-input-password {\n  .ant-input {\n    border: none !important;\n    padding: 0;\n    height: auto;\n    line-height: 1.4;\n    display: flex;\n    align-items: center;\n    box-shadow: none !important;\n  }\n\n  .ant-input-suffix {\n    display: flex;\n    align-items: center;\n  }\n}\n\n/* Enhanced Checkbox and Radio Styling */\n.admin-modern-form .ant-checkbox-wrapper,\n.admin-modern-form .ant-radio-wrapper {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  border: 1px solid #9ca3af;\n  border-radius: var(--radius-md);\n  transition: all 0.2s ease;\n  background: var(--surface-gray-50);\n\n  &:hover {\n    background: var(--surface-white);\n    border-color: var(--primary-light);\n    box-shadow: var(--shadow-sm);\n  }\n}\n\n/* Permissions Grid Layout */\n.admin-permissions-grid {\n  .ant-checkbox-group {\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 0.75rem;\n\n    @media (max-width: 768px) {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n\n.admin-modern-form .ant-checkbox-wrapper {\n  width: 100%;\n\n  .ant-checkbox {\n    .ant-checkbox-inner {\n      width: 20px;\n      height: 20px;\n      border-radius: var(--radius-sm);\n      border: 2px solid #9ca3af !important;\n      transition: all 0.2s ease;\n\n      &::after {\n        width: 6px;\n        height: 10px;\n        border-width: 0 3px 3px 0;\n      }\n    }\n\n    &.ant-checkbox-checked .ant-checkbox-inner {\n      background: var(--primary-gradient);\n      border-color: var(--primary-color);\n    }\n  }\n\n  span:last-child {\n    font-weight: 500;\n    color: var(--text-primary);\n    margin-left: 0.5rem;\n  }\n}\n\n/* Submit Button */\n.admin-create-btn {\n  min-width: 220px;\n  height: 44px;\n  font-size: 1rem;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: 0;\n  border: none;\n  border-radius: var(--radius-md);\n  background: var(--primary-color);\n  color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: #d97706;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  }\n\n  &:active {\n    transform: translateY(1px);\n  }\n\n  &[disabled] {\n    background: var(--text-muted);\n    box-shadow: none;\n    transform: none;\n  }\n}\n\n/* Custom Editor Styling */\n.admin-custom-editor-wrapper {\n  border: 2px solid var(--border-light);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  transition: all 0.2s ease;\n  background: var(--surface-white);\n\n  &:hover {\n    border-color: var(--primary-light);\n    box-shadow: 0 0 0 3px rgb(239 130 0 / 0.1);\n  }\n\n  &:focus-within {\n    border-color: var(--primary-color);\n    box-shadow: 0 0 0 4px rgb(239 130 0 / 0.15);\n  }\n\n  .admin-form-right-column & {\n    margin-top: 0;\n    min-height: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
